import { useEffect } from 'react';

export function usePageTitle(title: string) {
  useEffect(() => {
    const fullTitle = title ? `${title} | Beyond Class` : 'Beyond Class';
    document.title = fullTitle;
  }, [title]);
}
